import { DecimalPipe } from '@angular/common';
import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { NgbdSortableHeader } from '../directives/sortable.directive';
import { BaseService } from '../services/base.service';
import { DttableService } from '../services/dttable.service';

@Component({
  selector: 'app-designation-search',
  templateUrl: './designation-search.component.html',
  styles: [
  ],
  providers: [DttableService, DecimalPipe]
})
export class DesignationSearchComponent implements OnInit {

  listForm: FormGroup;
  dataSource = [];

  dataSources$: Observable<any[]>;
  total$: Observable<number>;

  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  constructor(public dtTableService: DttableService, private fb: FormBuilder,
    private baseService: BaseService, public activeModal: NgbActiveModal) {
    this.dataSources$ = this.dtTableService.dataSoruces$;
    this.total$ = this.dtTableService.total$;
  }

  ngOnInit(): void {
    this.createForm();
    this.getList(this.listForm.getRawValue());
  }

  createForm() {
    this.listForm = this.fb.group({
      Code: ['*'],
      Name: ['*']
    });
  }

  getList(ele) {
    this.baseService.callSecureAPI('POST', '/Appointment/GetDesignationList', null)
      .subscribe((res) => {
        const res_item = this.baseService.getReposnse(res);
        if (res_item) {
          this.dataSource = res_item;
          if (ele.Code != '' && ele.Code != '*') {
            this.dataSource = this.dataSource.filter(e => e.Code === ele.Code);
          }
          if (ele.Name != '' && ele.Name != '*') {
            this.dataSource = this.dataSource.filter(e => e.Title === ele.Name);
          }
          this.dtTableService.getDataSource(this.dataSource);
        }
      });
  }
  onSort({ column, direction }) {
    this.dtTableService.onSort({ column, direction }, this.headers);
  }

  selectDesignation(ele) {
    this.activeModal.close(ele);
  }

}
